import { render, staticRenderFns } from "./FeedImgItem.vue?vue&type=template&id=2fc2201a&scoped=true&"
import script from "./FeedImgItem.vue?vue&type=script&lang=js&"
export * from "./FeedImgItem.vue?vue&type=script&lang=js&"
import style0 from "./FeedImgItem.vue?vue&type=style&index=0&id=2fc2201a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc2201a",
  null
  
)

export default component.exports